import React, { useState } from "react";
import { motion } from "framer-motion";

export default function ContactPage() {
  const email = "chunlong.mu1@ucalgary.ca";
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(email).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      style={{
        padding: "4rem 2rem",
        maxWidth: "700px",
        margin: "0 auto",
        textAlign: "center",
        fontFamily: "Segoe UI, sans-serif",
      }}
    >
      <h1 style={{ color: "#0079C0", fontSize: "2rem", marginBottom: "1rem" }}>
        Contact Us
      </h1>

      <p style={{ fontSize: "1.1rem", color: "#333", marginBottom: "2rem" }}>
        For questions, feedback, or collaboration inquiries, please reach out:
      </p>

      <div
        style={{
          backgroundColor: "#f8fafc",
          padding: "1rem 2rem",
          borderRadius: "10px",
          display: "inline-block",
          border: "1px solid #e5e7eb",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
        }}
      >
        <p style={{ fontSize: "1rem", marginBottom: "0.5rem", color: "#0079C0" }}>
          <strong>Email:</strong>{" "}
          <a href={`mailto:${email}`} style={{ color: "#0079C0", textDecoration: "underline" }}>
            {email}
          </a>
        </p>

        <button
          onClick={handleCopy}
          style={{
            backgroundColor: "#0079C0",
            color: "white",
            border: "none",
            padding: "0.4rem 0.8rem",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "bold",
            fontSize: "0.9rem",
          }}
        >
          {copied ? "Copied!" : "Copy Email"}
        </button>
      </div>
    </motion.div>
  );
}